import * as React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../App";
import "./VideoPage.css";
import Header from "./Header";
import { useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import LandingPage from "./LandingPage";
import Box from "@mui/material/Box";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { Button } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";

const cardTitle = {
  fontSize: "3vw",
  color: "white",
  letterSpacing: "0.8px",
};

const vote = {
  minWidth: "60px",
  margin: "5px",
  backgroundColor: "rgb(49, 49, 49)",
  border: "none",
  color: "rgb(255, 255, 255)",
  borderRadius: "16px",
  cursor: "pointer",
  maxHeight: "5vh",
};

const VideoPage = (props) => {
  const { enqueueSnackbar } = useSnackbar();

  const [Data, setData] = useState({
    videoLink: "",
    title: "",
    viewCount: "",
  });
  const [upVote, setupVote] = useState(0);
  const [downVote, setdownVote] = useState(0);
  const [views, setviews] = useState(increaseViews);

  const location = useLocation();
  const vidId = location.state.videoId;


  const getVideoLink = async (vId) => {
    try {
      let url = `${config.endpoint}/v1/videos/${vId}`;
      const data = await axios.get(url);
      setData({
        videoLink: data.data.videoLink,
        title: data.data.title,
        viewCount: data.data.viewCount,
        releaseDate: data.data.releaseDate,
      });
    } catch (e) {
      if (e.response.status === 404) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar("No videos with matching Id", { variant: "error" });
      }
    }
    setviews(views + 1);
    localStorage.setItem("view", JSON.stringify(views));
  };

  useEffect(() => {
    getVideoLink(vidId);
  }, []);

  useEffect(() => {
    const initialupVote = localStorage.getItem("like");
    const initialdownVote = localStorage.getItem("dislike");
    if (initialupVote) setupVote(initialupVote);
    if (initialdownVote) setdownVote(initialdownVote);
  }, []);

  function increaseViews() {
    if (localStorage.getItem("view")) {
      return Number(localStorage.getItem("view")) + 1;
    } else {
      return 0;
    }
  }
  const increaseVoteCount = () => {
    const response = axios.patch(
      `${config.endpoint}/v1/videos/${vidId}/votes`,
      { votes: upVote },
      { headers: { "Content-Type": "application/json" } }
    );
    setupVote((prevupVote) => {
      const newlikeCount = Number(prevupVote) + 1;
      localStorage.setItem("like", newlikeCount);
      return newlikeCount;
    });
  };

  const decreaseVoteCount = () => {
    const response = axios.patch(
      `${config.endpoint}/v1/videos/${vidId}/votes`,
      { votes: upVote },
      { headers: { "Content-Type": "application/json" } }
    );
    setdownVote((prevdownVote) => {
      const newdislikeCount = Number(prevdownVote) + 1;
      localStorage.setItem("dislike", newdislikeCount);
      return newdislikeCount;
    });
  };
  return (
    <div>
      <Header />
      <div className="video-container">
        <Card className="iframe-main">
          <CardMedia>
            <iframe
              src={`https://${Data.videoLink}`}
              className="iframe-inside"
              allow="autoplay; encrypted-media"
              frameBorder="0"
              allowFullScreen
              title="video"
            ></iframe>
          </CardMedia>
          <CardContent className="video-content">
            <Typography gutterBottom variant="h5" style={cardTitle}>
              {Data.title}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: 0,
                m: 0,
                bgcolor: "none",
                borderRadius: 1,
              }}
            >
              <div>
                <Typography color="text.secondary" className="card-text">
                  <span style={{ margin: "10px" }}>{views} views</span>
                  <CircleIcon sx={{ width: "8px", height: "8px" }} />
                  {Data.releaseDate}
                </Typography>
              </div>
              <div>
                <Typography color="text.secondary" className="card-text">
                  <Button
                    variant="outlined"
                    style={vote}
                    onClick={increaseVoteCount}
                  >
                    <span style={{ margin: "5px" }}>
                      <ThumbUpIcon />
                    </span>
                    {upVote}
                  </Button>
                  <Button
                    variant="outlined"
                    style={vote}
                    onClick={decreaseVoteCount}
                  >
                    <span style={{ margin: "5px" }}>
                      <ThumbDownIcon />
                    </span>
                    {downVote}
                  </Button>
                </Typography>
              </div>
            </Box>
          </CardContent>
        </Card>
        <LandingPage hasAuthButtons={true} />
      </div>
    </div>
  );
};
export default VideoPage;
